import strings from 'owa-strings/owa-mail-strings';
/**
 * Get rollup text for current folder
 */
export default function getRollupText(viewType) {
    var rollupText;
    switch (viewType) {
        case 1 /* FocusedView */:
            rollupText = strings.focusedNewConversationsRollupText;
            break;
        case 2 /* ClutterView */:
            rollupText = strings.otherNewConversationsRollupText;
            break;
    }
    return rollupText;
}
//# sourceMappingURL=getRollupText.js.map